<template>
    <div class="container q-my-md title" :class="'lang'+lang">
        <h2 class="page-title" v-html="title ? title : ''" style="margin-left: 15px"></h2>
        <div class="page-description" v-if="subtitle" v-html="subtitle"></div>
        <div class="page-description" v-else></div>
        <div v-if="back" class="back" :class="'back'+lang"><q-btn flat round size="sm" color="secondary" :icon="direction"
                                                                  @click="$router.go(-1)"></q-btn></div>
    </div>
</template>

<script>
import {
    QBtn
} from 'quasar-framework'

export default {
    name: 'VTitle',
    data() {
        return {
            lang: window.config.locale.toUpperCase(),
            direction: '',
        }
    },
    mounted(){
        if (this.lang === 'AR'){
            this.direction = 'arrow right'
        }else{
            this.direction = 'arrow left'
        }
    },
    props: {
        title: {
            type: String,
            required: true
        },
        subtitle: String,
        back: {
            type: Boolean,
            default: true
        }
    },

    components: {
        QBtn
    }
}
</script>
<style scoped>
.langAR{
    text-align: right;
}
.backAR{
    right: -15px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/front/Title.vue